// extracted by mini-css-extract-plugin
export default {"PFSWhatWeDoLegal":"PFSWhatWeDoLegal_PFSWhatWeDoLegal__45EOo"};